import i18next from 'i18next';
import { z } from 'zod';

export const repairServiceSchema = z.object({
  id: z.string().optional(),
  name: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('repairService:repairServiceNameRequired'),
      });
    }
  }),
  description: z.string().nullish(),
  active: z.boolean().default(true),
});

export type TRepairServiceSchema = z.infer<typeof repairServiceSchema>;
